// @flow
import type { Region } from 'shared/types';

// Retrieve ENV settings, set from client-env.js
const getSetting = (key) => {
  if (window && window._env_) {
    return window._env_[key];
  }

  return null;
};

// Use for accessing the API
// Returns region-specific API domain for genesis/localhost,
// or empty string (relative URL) for ff.com
const getAPIDomain = (region: Region) => {
  if (isGenesisOrLocalhost()) {
    const apiDomain = region === 'CN' ?
      getSetting('API_DOMAIN_CN') :
      getSetting('API_DOMAIN_US');

    return apiDomain || '';
  }

  return '';
};

// Use for getting the region-specific base URL
const getWebDomain = (region: Region) => {
  const webDomain = region === 'CN' ?
    getSetting('API_DOMAIN_CN') :
    getSetting('API_DOMAIN_US');
  const defaultDomain = region === 'CN' ?
      'https://www.faradayfuturecn.com' :
      'https://www.ff.com';

  return webDomain || defaultDomain;
}

const getHideSubscribeFlag = (region: Region) =>
  region === 'CN' ?
    getSetting('HIDE_SUBSCRIBE_CN') :
    getSetting('HIDE_SUBSCRIBE_US');

const getFreeRideEndDate = () =>
  getSetting('FREE_RIDE_END_DATE');

const getClientAssetsURLPrefix = () =>
  getSetting('CLIENT_ASSETS_URL_PREFIX');

const getS3AssetsManagement = () =>
  getSetting('S3_ASSETS_MANAGEMENT');

const getAppURL = () =>
  getSetting('APP_URL');

const getMinimumMinutesBetweenDeployments = () =>
  getSetting('MINIMUM_MINUTES_BETWEEN_DEPLOYMENTS');

const getMaximumScheduledDeployments = () =>
  getSetting('MAXIMUM_SCHEDULED_DEPLOYMENTS');

const getMinimumDeploymentIntervalLimitHrs = () =>
  getSetting('MINIMUM_DEPLOYMENT_INTERVAL_LIMIT_HRS');

// True if client is in Genesis app or localhost
const isGenesisOrLocalhost = () =>
  typeof window !== 'undefined' &&
  /(genesis.(ffau.to|ff.com)|localhost)/.test(window.location.href);

const getGenesisCDN = (region: Region) =>
  region === 'CN' ?
    getSetting('GENESIS_CDN_CN') :
    getSetting('GENESIS_CDN_US');

const getRedirectForAR = () => getSetting('REDIRECT_FOR_AR');

const getGoogleRecaptchaApiKey = () => getSetting('GOOGLE_RECAPTCHA_KEY_ID');

export {
  getAPIDomain,
  getWebDomain,
  getHideSubscribeFlag,
  getFreeRideEndDate,
  getClientAssetsURLPrefix,
  getS3AssetsManagement,
  getAppURL,
  getMinimumMinutesBetweenDeployments,
  getMaximumScheduledDeployments,
  getMinimumDeploymentIntervalLimitHrs,
  getGenesisCDN,
  getRedirectForAR,
  getGoogleRecaptchaApiKey
}

